module.exports = __webpack_public_path__ + "img/限时商品5.39e5bca9.png";